export default __webpack_public_path__ + "static/media/Andresa_Guidelli_AHV_In_Moms_We_Trust.7e38b89d.jpg";